var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp-chat-empty"},[_c('div',{staticClass:"comp-chat-empty-wrap"},[_c('div',{staticClass:"comp-chat-empty-img"}),_c('div',{staticClass:"comp-chat-empty-text"},[_c('p',[_vm._v(_vm._s(_vm.showText))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }